export const subscriptionConstants = {
  GET_ALL_PLANS: "GET_ALL_PLANS",
  SUBSCRIBE: "SUBSCRIBE",
  GET_SUBSCRIPTIONS: "GET_SUBSCRIPTIONS",
  GET_SUBSCRIPTION_PLANS: "GET_SUBSCRIPTION_PLANS",
  CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",
  CHANGE_CARD: "CHANGE_CARD",
  GET_USER_SUBSCRIPTION_STATUS: "GET_USER_SUBSCRIPTION_STATUS",
  FETCH_INVOICE: "FETCH_INVOICE",
};

export const TABS = {
  MONTHLY: 1,
  SEASONAL: 2,
  ANNUAL: 3,
};

export const TAB_NAME = {
  [TABS.MONTHLY]: "Monthly",
  [TABS.SEASONAL]: "Biannual (6 Months)",
  [TABS.ANNUAL]: "Annual",
};

export const SUBSCRIPTION_PLAN_TYPE_NAME = {
  1: "1 Month",
  2: "6 Months",
  3: "1 Year",
};

export const SUBSCRIPTION_PLAN_MAPPING = {
  0: "Free Trial",
  1: "Standard",
  2: "Beginner",
  3: "Professional",
  4: "Premium",
};

export const SUBSCRIPTION_PLAN_TYPE_MAPPING = {
  1: "Monthly",
  2: "Biannual",
  3: "Annual",
};

export const CUSTOMER_SUBSCRIPTION_PLAN_TYPE_MAPPING = {
  1: "Monthly Membership",
  2: "Biannual Membership",
  3: "Annual Membership",
};

export const SUBSCRIPTION_STATUS_MAPPING = {
  1: "Not Subscribed",
  2: "Pending",
  3: "Deactivated",
  4: "Active",
  5: "Expired",
  6: "Cancelled",
  7: "Update Card Info",
  8: "Paused",
  9: "On Hold",
  10: "Cancelled",
};

export const SUBSCRIPTION_PLAN_BUTTON_NAME = {
  UPDATE: "Update",
  SUBSCRIBED: "Subscribed",
  GET_STARTED: "Get Started",
  START_FREE_TRIAL: "Start Free Trial",
};

export const SUBSCRIPTION_PAYMENT_STATUS = {
  PENDING: "pending",
};
